import { wbFetch } from "./wbFetch";

type WbErroredGood = {
  batchUUID: string;
  subjects: {
    [sku: string]: {
      id: number;
      name: string;
    };
  };
  brands: any;
  vendorCodes: string[];
  errors: {
    [sku: string]: string[];
  };
};

export const getWbErroredGoods = async (): Promise<WbErroredGood[]> => {
  const body = {
    cursor: {
      limit: 100,
    },
    order: {
      ascending: true,
    },
  };

  const response = await wbFetch(`https://content-api.wildberries.ru/content/v2/cards/error/list`, "POST", JSON.stringify(body));

  // console.log(response.data.cursor)

  if (!response?.data?.items) {
    return [];
  }

  // console.log(response.data.items)

  return response.data?.items ?? [];
};
